<template>
    <div class="ranking-container">
        <div class="tabs">
            <button :class="{ 'active': activeTab === 'comparison' }" @click="activeTab = 'comparison'">
                比較表で見る
            </button>
            <button :class="{ 'active': activeTab === 'ranking' }" @click="activeTab = 'ranking'">
                総合ランキングで見る
            </button>
        </div>

        <div class="tab-content">
            <div v-if="activeTab === 'ranking'" class="ranking-list">
                <div class="ranking-card rank-1 flashing-border">
                    <span class="rank-badge">1位</span>
                    <img src="../../assets/rank-table/vendor-1.png" alt="給湯器駆けつけ隊">
                    <div class="card-content">
                        <p class="plan-title under-yellow">総合評価：<span style="color: #ff9800;">★★★★★</span></p>
                        <h3 class="vendor-name">給湯器駆けつけ隊</h3>
                    </div>
                    <a :href="affiliateLink" target="_blank" rel="nofollow noopener" class="cta-button">公式サイト▶︎</a>
                </div>
                <div class="ranking-card rank-2">
                    <span class="rank-badge">2位</span>
                    <img src="../../assets/rank-table/vendor-2.png" alt="キンライサー">
                    <div class="card-content">
                        <p class="plan-title bold-font">総合評価：★★★★</p>
                        <h3 class="vendor-name">キンライサー</h3>
                    </div>
                    <a href="https://www.kyutooki.com/gas/" target="_blank" class="cta-button">公式サイト
                        ▶︎</a>
                </div>
                <div class="ranking-card rank-3">
                    <span class="rank-badge">3位</span>
                    <img src="../../assets/rank-table/vendor-3.png" alt="街角給湯相談所">
                    <div class="card-content">
                        <p class="plan-title bold-font">総合評価：★★★★</p>
                        <h3 class="vendor-name">街角給湯相談所</h3>
                    </div>
                    <a href="https://lp.machikado-sodan.com/ab/XpBiwJMXRLixOgatw" target="_blank"
                        class="cta-button">公式サイト ▶︎</a>
                </div>
            </div>

            <div v-if="activeTab === 'comparison'" class="comparison-table">
                <RankingTable />
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from 'vue'
import RankingTable from './RankingTable.vue'
import { makeAffiliateUrl } from '@/utils/aff.js'

export default {
    name: 'RankingAndComparison',
    components: { RankingTable },
    props: {
        defaultTab: {
            type: String,
            default: 'ranking',
            validator: (val) => ['ranking', 'comparison'].includes(val)
        }
    },
    setup(props) {
        const activeTab = ref(props.defaultTab)
        watch(() => props.defaultTab, (newVal) => {
            activeTab.value = newVal
        })

        return { activeTab }
    },
    computed: {
        affiliateLink() {
            return makeAffiliateUrl();
        }
    },
}
</script>

<style scoped>
.ranking-container {
    background-color: #eef5ff;
}

.tabs {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    margin-bottom: 20px;
}

.tabs button {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    color: #3f51b5;
    transition: all 0.3s;
}

.tabs button:first-child {
    border-radius: 5px 0 0 5px;
}

.tabs button:last-child {
    border-radius: 0 5px 5px 0;
}

.tabs button.active {
    background-color: #3f51b5;
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.tab-content {
    padding-bottom: 30px;
}

.ranking-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.ranking-card {
    position: relative;
    background-color: #f8f9fa;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    gap: 20px;
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 20px;
}

.ranking-card.rank-1 {
    background-color: #f7f9fd;
    border: 5px solid #bfb029;
}

.rank-badge {
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ffc107;
    color: white;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 20px;
    font-weight: bold;
}

.rank-2 .rank-badge {
    background-color: #aba4a4;
}

.rank-3 .rank-badge {
    background-color: #a0522d;
}

.ranking-card img {
    width: 30%;
    height: auto;
    margin-bottom: 0;
}

.card-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.vendor-name {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0;
}

.plan-title {
    margin: 0;
}

.price {
    font-size: 24px;
    font-weight: bold;
    color: #d9534f;
    margin-top: 5px;
}

.price-unit {
    font-size: 16px;
    font-weight: normal;
}

.cta-button {
    display: inline-block;
    background-color: #d9534f;
    color: white;
    padding: 10px 20px;
    text-decoration: none;
    font-weight: bold;
    transition: background-color 0.3s;
    white-space: nowrap;
}

.cta-button:hover {
    background-color: #5c6bc0;
}

@keyframes flash-border {
    0% {
        border-color: #bfb029;
    }

    50% {
        border-color: transparent;
    }

    100% {
        border-color: #bfb029;
    }
}

.flashing-border {
    border: 2px solid #bfb029;
    animation: flash-border 2.0s infinite;
}


@media (max-width: 600px) {
    .tabs button {
        font-size: 1.1rem;
    }

    .ranking-card {
        display: grid;
        grid-template-columns: 38% 62%;
        align-items: center;
        gap: 0px 5px;
        padding: 12px;
        text-align: left;
    }

    .ranking-card img {
        grid-column: 1;
        grid-row: 1 / 4;
        width: 100%;
        height: auto;
        margin: 0;
    }

    .card-content {
        grid-column: 2;
        grid-row: 1 / 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 3px;
        text-align: center;
    }

    .plan-title {
        font-size: 1rem;
        margin: 0;
    }

    .vendor-name {
        font-size: 1rem;
        margin: 0;
    }

    .cta-button {
        grid-column: 2;
        grid-row: 3;
        width: 90%;
        padding: 8px 0;
        border-radius: 5px;
        text-align: center;
        justify-self: center;
        font-size: 1.1rem;
        margin: 2px 0 0 0;
    }

    .rank-badge {
        top: -25px;
        font-size: 1.2rem;
        padding: 3px 10px;
    }
}

@media (max-width: 480px) {
    .tabs button {
        font-size: 0.8rem;
    }

    .ranking-card {
        display: grid;
        grid-template-columns: 38% 62%;
        align-items: center;
        gap: 0px 5px;
        padding: 12px;
        text-align: left;
    }

    .ranking-card img {
        grid-column: 1;
        grid-row: 1 / 4;
        width: 100%;
        height: auto;
        margin: 0;
    }

    .card-content {
        grid-column: 2;
        grid-row: 1 / 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 3px;
        text-align: center;
    }

    .plan-title {
        font-size: 0.8rem;
        margin: 0;
    }

    .vendor-name {
        font-size: 0.8rem;
        margin: 0;
    }

    .cta-button {
        grid-column: 2;
        grid-row: 3;
        width: 90%;
        padding: 8px 0;
        border-radius: 5px;
        text-align: center;
        justify-self: center;
        font-size: 0.7rem;
        margin: 2px 0 0 0;
    }

    .rank-badge {
        top: -25px;
        font-size: 1rem;
        padding: 3px 10px;
    }
}
</style>
